export function TalentPoolSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/talent-pool.svg'"></ng-include>`
    }
}